import useTranslator from "../hooks/useTranslator";
import { Button, Modal } from "./design";

const SwitchUserConfirmationModal = ({
  onClose,
  type,
  email,
  handleChangeUser,
}) => {
  const { _t } = useTranslator();
  const oppoType = type === "tenant" ? "landlord" : "tenant";
  // "Continue as" + the same role name used everywhere else ("Tenant",
  // "Landlord or Agent"), so the casing always matches
  const continueAs = (role) =>
    _t("continueAsRole", "", "translation", { role: _t(role) });
  return (
    <Modal
      open
      onClose={onClose}
      dismissible={false}
      actionsLayout="stack"
      title={_t(`${oppoType}AlreadyExistDoYouWantToContinueAs${type}`)}
      description={
        <>
          {_t("thisEmail")} <strong>{email}</strong>{" "}
          {_t(`alreadyExistAsA${oppoType}`)}
        </>
      }
      actions={
        <>
          <Button variant="primary" size="lg" onClick={handleChangeUser}>
            {continueAs(oppoType)}
          </Button>
          <Button variant="secondary" size="lg" onClick={onClose}>
            {continueAs(type)}
          </Button>
        </>
      }
    />
  );
};

export default SwitchUserConfirmationModal;
